import fallbackNews from "../data/news.json";

export const NEWS_API_URL = process.env.REACT_APP_NEWS_API_URL || "";

export const normalizeNewsList = (payload) => {
  if (!payload) return [];
  if (Array.isArray(payload.items)) return payload.items;
  if (Array.isArray(payload.data)) return payload.data;
  if (Array.isArray(payload)) return payload;
  if (typeof payload === "object") return Object.values(payload);
  return [];
};

export const fetchNewsList = async (url = NEWS_API_URL) => {
  if (!url) return normalizeNewsList(fallbackNews);
  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`Failed to fetch news (${response.status})`);
    }
    const data = await response.json();
    const normalized = normalizeNewsList(data);
    return normalized.length ? normalized : normalizeNewsList(fallbackNews);
  } catch (error) {
    return normalizeNewsList(fallbackNews);
  }
};

export const buildNewsSlugMap = (newsItems) => {
  const map = { en: {}, sr: {} };
  if (!Array.isArray(newsItems)) return map;

  newsItems.forEach((news) => {
    if (!news) return;
    if (news.path) {
      map.en[news.path] = news;
      map.sr[news.path] = news;
    }
    if (news.sr_path) {
      map.sr[news.sr_path] = news;
    }
  });

  return map;
};

export const getNewsItemBySlug = (newsMap, slug) => {
  if (!newsMap || !slug) return null;
  return newsMap.en?.[slug] || newsMap.sr?.[slug] || null;
};
